import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './MainNavbar.scss';
import { ReactComponent as ThinnectSmallLogo } from './../assets/icons/NN_logo.svg';

type Props = {
	windowSize: { width: number | undefined; height: number | undefined };
	isLoggedIn: boolean;
	tenancyStatus: boolean;
	withoutToken: boolean;
	multipleTenancy: boolean;
	isAdmin: boolean;
	emitClientSiteChange: () => void;
	emitLogout: () => void;
};

const MainNavbar = ({
	windowSize,
	isLoggedIn,
	tenancyStatus,
	withoutToken,
	multipleTenancy,
	isAdmin,
	emitClientSiteChange,
	emitLogout,
}: Props) => {
	const [toggleNavbar, setToggleNavbar] = useState<boolean>(false);

	useEffect(() => {
		if (windowSize.width && windowSize.width > 768) {
			document.body.style.overflowY = '';
			setToggleNavbar(false);
		}
	}, [windowSize]);

	function toggleNavbarStatus(status: boolean): void {
		if (status !== toggleNavbar) {
			document.body.style.overflowY = !toggleNavbar ? 'hidden' : '';
			setToggleNavbar(status);
		}
	}

	function logout() {
		toggleNavbarStatus(false);
		emitLogout();
	}

	function changeClient() {
		toggleNavbarStatus(false);
		emitClientSiteChange();
	}

	return (
		<Navbar expand="md" variant="light" expanded={toggleNavbar} collapseOnSelect={true}>
			<Container fluid>
				<Navbar.Brand>
					<ThinnectSmallLogo className="thinnect-small-logo" />
				</Navbar.Brand>
				{isLoggedIn && (
					<Navbar.Toggle
						aria-controls="navbar-nav"
						onClick={() => toggleNavbarStatus(!toggleNavbar)}
					/>
				)}
				{isLoggedIn && (
					<Navbar.Collapse id="navbar-nav">
						<Nav className="ms-md-auto">
							{tenancyStatus && (
								<>
									<Nav.Link onClick={() => toggleNavbarStatus(false)} as={NavLink} to="/dashboard">
										Kõik ruumid
									</Nav.Link>
									<Nav.Link onClick={() => toggleNavbarStatus(false)} as={NavLink} to="/analyze">
										Analüüs
									</Nav.Link>
									<Nav.Link
										onClick={() => toggleNavbarStatus(false)}
										href="https://thinnect.com/et/airpurity/korduma-kippuvad-kusimused-kkk/"
									>
										Info
									</Nav.Link>
									{!withoutToken && multipleTenancy && (
										<Nav.Link onClick={() => changeClient()}>Asutus</Nav.Link>
									)}
								</>
							)}
							{isAdmin && (
								<NavDropdown title="Admin valikud" id="basic-nav-dropdown" align={'end'}>
									<NavDropdown.Item href="admin">Admin paneel</NavDropdown.Item>
									<NavDropdown.Divider />
									<NavDropdown.Item href="airpurity-commissioning">
										Airpurity seadistamine
									</NavDropdown.Item>
								</NavDropdown>
							)}
							<Nav.Link onClick={() => logout()}>Logi välja</Nav.Link>
						</Nav>
					</Navbar.Collapse>
				)}
			</Container>
		</Navbar>
	);
};

export default MainNavbar;
